module.exports = __webpack_public_path__ + "media/images/pc/top/recommend-plan-wedding3-c15c513905d7bd67d8bde312e7b51b70.jpg";